import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MarianomGeneral } from '../../marianom-general.service';
import { AuthService } from 'projects/mariano-max/src/app/core/auth/auth.service';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, SucursalEcommerce, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { CheckboxSubcategoria } from '../../etc/categoria-checkbox.interface';
import { MenuMmaxInterface } from '../../etc/mmax-menu.interface';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SocialAuthService } from '@abacritt/angularx-social-login';


@Component({
  selector: 'login-form-mmax',
  templateUrl: './login-form-mmax.component.html',
  styleUrls: ['./login-form-mmax.component.scss']
})

export class LoginFormMmaxComponent implements OnInit {
  @Input('mode') modo: string;
  @Input() registroHab: string;
  @Input() beneficiosTrue: string;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private modal: ModalService,
    private serv: MarianomGeneral,
    private genServ: EcommerceGenericoService,
    private router: ActivatedRoute,
    private authService: AuthService,
    private socialAuthService: SocialAuthService,
    private elRef: ElementRef
  ) {

    this.imagen = '../../assets/misc/compra.png'
    this.icogoogle = '../../assets/icons/google-logo.svg'
    this.icoface = '../../assets/icons/facebook-logo.svg'
    this.preImages = [this.imagen, this.icoface, this.icogoogle];
    this.modo = this.modo || 'normal';
    this.registroHab = this.registroHab || 'none';
    this.beneficiosTrue = this.beneficiosTrue || 'none';
    this.loginok = false;
    this._destroyed$ = new Subject();

  }

  salirMobile() {
    this.serv.navigator.goLandPage(this.router);
  }

  ngOnInit(): void {

    this.loginform = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    if (this.authService.isLogueado()) {
      if (this.serv.navigator?.goLandPage) {
        this.serv.navigator.goLandPage(this.router);
      }
    }

    this.router.data.subscribe(data => {
      this.modo = data['mode'] || this.modo || 'normal';
    })

    // El botón de Google mide mal (iframe con altura por defecto de 800px) si se
    // renderiza mientras el modal de login todavía está en display:none. Por eso
    // se retrasa hasta que el elemento sea visible o el modal se abra explícitamente.
    this.modal.onModalOpened.pipe(takeUntil(this._destroyed$)).subscribe(id => {
      if (id === 'login-modal-1') {
        this.googleButtonReady = true;
      }
    });
    setTimeout(() => {
      if (this.elRef.nativeElement.offsetParent !== null) {
        this.googleButtonReady = true;
      }
    });
    this.genServ.getRegistroHabilitado().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      // console.log(data);

      if (data === "S") {
        this.registroHab = 'flex';
      } else {
        this.registroHab = 'none';
      }
    });

    this.genServ.returnBeneficios().subscribe(data => {
      if (data == 'S') {
        this.beneficiosTrue = 'flex';
      } else {
        this.beneficiosTrue = 'none';
      }
    })


    this.preImages.forEach(async k => {
      new Image().src = k;
    });
    this.loginform = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    this.socialAuthService.authState.pipe(takeUntil(this._destroyed$)).subscribe((user) => {
      if (user) {
        this.genServ.loginConGoogle(user.idToken).subscribe({
          next: () => {
            this.loginok = true;
            this.serv.loginok();
          },
          error: (err) => {
            // Si loginConGoogle falla, cerramos la sesión de Google para no quedar en un estado a medias
            // y liberamos pendingLogin para que un próximo intento no quede bloqueado.
            console.error('loginConGoogle falló:', err);
            this.genServ.pendingFalse();
            this.socialAuthService.signOut();
            this.errorgen = err?.error?.error || err?.error?.mensaje || err?.error?.message
              || 'No pudimos completar el ingreso con Google. Por favor, intentá de nuevo o usá tu email y contraseña.';
            this.loginform.setErrors({ incorrect: true });
          }
        });
      }
    });

  }

  codigoAccesoPorMail(): void {
    this.modal.open('modal-no-implemented');
  }

  createUser() {
    this.modal.open('create-user-modal-1');
    this.modal.close('login-modal-1');
  }

  resetPass() {
    this.modal.open('send-reset-pass-modal-1');
    this.modal.close('login-modal-1');
  }

  restorePasswordMmax() {
    this.modal.open('restore-pass-modal');
    this.modal.close('login-modal-1');
  }

  cerrarModale(nombre) {
    this.modal.close(nombre);
  }

  submitForm() {
    //console.log("Ingresando");

    this.serv.llamarSpinner();
    this.genServ.loginStart(this.formFields?.username.value.trim(), this.formFields?.password.value.trim()).subscribe(data => {
      for (let i = 0; i < this.menus.length; i++) {
        const element = this.menus[i];
        element.activo = false;
      }
      this.serv.cerrarSpinner();
      this.loginok = true;
      //this.serv.gotoURL('', this.router)
      this.serv.loginok();
      //console.log("Login ok");

    }, err => {
      // console.log("Error login");

      this.genServ.pendingFalse();
      this.serv.cerrarSpinner();
      this.loginform.setErrors({ incorrect: true })
      this.errorgen = err['error']['mensaje'];
      this.loginok = false;
    });

  }

  crearCuentea() {
    this.serv.navigator.goCrearAccount(this.router);
  }

  recuperarPassword() {
    this.serv.navigator.goResetPass(this.router);
  }

  get formFields() {
    return this.loginform.controls;
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  get nombreSitio() {
    return this.genServ.getNombreSitio();
  }

  get mostrarLoginGoogle() {
    return this.genServ.getLoginGoogle();
  }

  // El boton de Google Identity Services no acepta un ancho fluido (% o
  // auto): pide un [width] fijo en px. 368 (el valor original) se
  // desbordaba del modal en mobile, donde el padding deja menos espacio
  // disponible. Se recalcula contra el viewport real en vez de hardcodear
  // un segundo numero fijo para mobile.
  get anchoBotonGoogle(): number {
    return Math.min(368, window.innerWidth - 64);
  }

  get mostrarLoginCodigoMail() {
    return this.genServ.getLoginCodigoMail();
  }

  loginform: UntypedFormGroup;
  preImages: string[];
  imagen: string;
  icoface: string;
  icogoogle: string;
  errorgen: string;
  sucursalesPropias: SucursalEcommerce[];
  sucursalSelecionada: SucursalEcommerce;
  usuario: Usuario;
  loginok: boolean;
  googleButtonReady: boolean = false;
  private _destroyed$: Subject<any>;

}
